import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { extendURLParams } from "@/utils/fetchData";
import { PageHeader, PageFooter } from "@/components/organisms";
import { StandardPageTemplate } from "@/components/templates";
import { Box, HeadlineSourceSansPro, Surface } from "@mm/ui";
import PageSections from "@/pages/PageSections";
import "./style.scss";
const HandraiserSection = () => {
    const { tenant, environment, restUrl } = extendURLParams();
    const [codeIsValid, setCodeIsValid] = useState(false);
    const [codeInfos, setCodeInfos] = useState();
    const { register, reset, handleSubmit, watch, getFieldState, setError, formState: { errors }, } = useForm();
    const onSubmit = (data) => {
        if (codeInfos?.redeemed === false) {
            const redeemed = fetch(`${restUrl}/v1/samsung/market/redeem?tenant=${tenant}&environment=${environment}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
                .then((response) => {
                return response.json();
            })
                .then((data) => {
                if (data.statusCode === 200) {
                    setCodeIsValid(true);
                    setCodeInfos(data);
                }
                if (data.statusCode === 400) {
                    data.validationErrors.map(({ name, type, message }) => {
                        setError(name, { type, message });
                    });
                }
            })
                .catch((error) => {
                // Handle errors
                // eslint-disable-next-line no-console
                console.error("There was a problem with the fetch operation:", error);
            });
            return redeemed;
        }
        else {
            fetch(`${restUrl}/v1/samsung/market/validate?tenant=${tenant}&environment=${environment}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
                .then((response) => {
                return response.json();
            })
                .then((data) => {
                if (data.statusCode === 200) {
                    setCodeIsValid(true);
                    setCodeInfos(data);
                }
                if (data.statusCode === 400) {
                    data.validationErrors.map(({ name, type, message }) => {
                        setError(name, { type, message });
                    });
                }
            })
                .catch((error) => {
                // Handle errors
                // eslint-disable-next-line no-console
                console.error("There was a problem with the fetch operation:", error);
            });
        }
    };
    return (_jsxs(Surface, { variant: "narrow", shape: "roundedSmall", mt: "6", children: [_jsx(Box, { mb: "4", children: _jsx(HeadlineSourceSansPro, { size: "35px", type: "h1", text: "Statusabfrage Handraiser-Code", weight: "600", mt: "0", mb: "4" }) }), _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "handraiserForm", children: [_jsx("div", { className: "margin-b-4", children: _jsx("p", { children: "Gib hier den Handraiser-Code und deine Markt-ID ein, um den Status zu pr\u00FCfen." }) }), _jsxs("div", { className: "container margin-b-4", children: [_jsx("div", { className: "col-6", children: _jsxs("div", { className: "textInputWrapper", children: [_jsx("label", { className: `textInputLabel margin-b-1 ${errors.code && "error"}`, htmlFor: "code", children: "Handraiser-Code*" }), _jsx("input", { className: `textInput ${getFieldState("code").error && "error"} ${watch("code")?.length >= 1 && "dirty"}`, id: "code", ...register("code", { required: true }) }), errors.code && (_jsx("span", { className: "textInputError margin-t-1", children: errors.code.message
                                                ? errors.code.message
                                                : "Das ist ein Pflichtfeld" }))] }) }), _jsx("div", { className: "col-6", children: _jsxs("div", { className: "textInputWrapper", children: [_jsx("label", { className: `textInputLabel margin-b-1 ${errors.marketCode && "error"}`, htmlFor: "marketCode", children: "Markt-ID*" }), _jsx("input", { className: `textInput ${errors.marketCode && "error"} ${watch("marketCode")?.length >= 1 && "dirty"}`, id: "marketCode", ...register("marketCode", { required: true }) }), errors.marketCode && (_jsx("span", { className: "textInputError margin-t-1", children: errors.marketCode.message
                                                ? errors.marketCode.message
                                                : "Das ist ein Pflichtfeld" }))] }) })] }), !codeIsValid && (_jsx("button", { className: "btnSubmit", type: "submit", children: "Jetzt pr\u00FCfen" })), codeIsValid && codeInfos && (_jsxs(_Fragment, { children: [_jsxs("p", { children: ["Status:", " ", _jsx("b", { children: codeInfos.redeemed ? "eingelöst" : "nicht eingelöst" })] }), codeInfos.redeemedAt && (_jsxs("p", { children: ["Einl\u00F6sedatum: ", _jsx("b", { children: codeInfos.redeemedAt })] })), _jsx("button", { className: "btnSubmit margin-t-4 margin-r-5", type: "button", onClick: () => {
                                    reset();
                                    setCodeIsValid(false);
                                }, children: "Leeren" }), _jsx("button", { className: "btnSubmit", type: "submit", disabled: codeInfos.redeemed, children: "Einl\u00F6sen" })] }))] })] }));
};
export const HandraiserCode = ({ page, voucherCode }) => {
    return (_jsx(StandardPageTemplate, { header: _jsx(PageHeader, { itemCount: 1 }), sections: [
            _jsx(HandraiserSection, {}, "HandraiserSection"),
            _jsx(PageSections, { sections: page.sections, variant: page.siteType, voucherCode: voucherCode }, "PageSections"),
        ], footer: _jsx(PageFooter, {}) }));
};
